import React, { useState } from "react";
import Start_Btn from "../../common/start-btn/Start_Btn";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";

const Parental_Banner = ({ pbanner }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section className="Parental_Banner Career_Banner">
        <div className="container">
          <div className="career_content">
            <h5 className="career_title">
              {/* Guiding Parents for Confident Career Decisions */}
              {pbanner?.name}
            </h5>
            <p className="career_text">
              {/* Dedicated counselling support to help parents Understand their child
            and Career options, streams, and informed decision-making for their
            children. */}
              {pbanner?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
            </p>
            <Start_Btn text="Book Session" onClick={() => setShowModal(true)} />
          </div>
        </div>
      </section>
      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default Parental_Banner;
